import dayjs from 'dayjs';
import { EICSForm, EICSTransitionLookupValues } from '../../utils/type';
import { ApiMessage, ApiResponseHandler } from '../ApiResponseHandler';
import ThomApiClient from '../ThomApiClient';
import { REFERRAL_PROGRAM_KEY } from '../Constant';

export const getEICSLookupValues =
  async (): Promise<EICSTransitionLookupValues> => {
    return ApiResponseHandler(await ThomApiClient.getInstance().get(`lookup`));
  };

export const getTransitiondata = async (
  clientId: string | null | undefined,
): Promise<EICSForm> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().get(
      `client/transition?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
    ),
  );
};

export const addTransitionData = async (
  params: EICSForm,
  clientId: string | null | undefined,
): Promise<ApiMessage> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  const timezone = encodeURIComponent(dayjs(new Date()).format('Z'));
  const url = `client/transition?timezone=${timezone}&clientId=${clientId}&referralProgramId=${
    referralProgramId ?? ''
  }`;

  return ApiResponseHandler(
    await ThomApiClient.getInstance().post(url, params),
  );
};
